import OutlinedFieldFormik from './outlinedFieldFormik'
import React from 'react'
import FormatedInput from '../../common/fields/formatedInput'

const YearFieldFormik = (props: React.ComponentProps<typeof OutlinedFieldFormik>) => {
  return (
    <OutlinedFieldFormik
      placeholder='2024'
      InputProps={{
        inputComponent: FormatedInput as any,
      }}
      inputProps={{
        mask: Number,
        min: '1000',
        max: String(new Date().getFullYear() + 1),
        scale: 0, // No decimal places
        normalizeZeros: true,
      }}
      {...props}
    />
  )
}

export default YearFieldFormik
